export {
  ECMA_SCRIPT_MEMBER_ACCESS_RULES as TYPESCRIPT_MEMBER_ACCESS_RULES,
} from './javascript.js';
